import { render, staticRenderFns } from "./NewChatPlatformIcon.vue?vue&type=template&id=240a55d0"
import script from "./NewChatPlatformIcon.vue?vue&type=script&lang=js"
export * from "./NewChatPlatformIcon.vue?vue&type=script&lang=js"
import style0 from "./NewChatPlatformIcon.vue?vue&type=style&index=0&id=240a55d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports